import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface ErrorPageProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorPage({ message, onRetry }: ErrorPageProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-custom-orange-50 via-custom-orange-100 to-custom-orange-200 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-[30px] shadow-xl max-w-md w-full text-center">
        <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h2 className="text-xl font-bold text-gray-900 mb-2">Something went wrong</h2>
        <p className="text-gray-600 mb-6">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="w-full px-6 py-3 bg-custom-orange-400 text-white rounded-xl font-semibold hover:bg-custom-orange-500 transition-colors"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}